
  import Header from '@/components/Header.vue';
  import { Options, Vue } from 'vue-class-component';
  import ResetPassword from '@/components/ResetPassword.vue';

  @Options({
    components: {
      Header,
      ResetPassword
    }
  })
  export default class ResetPasswordComponent extends Vue {}
